export const HOME_SCREEN = "HOME_SCREEN";
export const COMUNICATION_ERROR_SCREEN = "COMUNICATION_ERROR_SCREEN";
export const WRONG_NUMBER_SCREEN = "WRONG_NUMBER_SCREEN";
export const TRIES_ERROR_SCREEN = "TRIES_ERROR_SCREEN";
export const MESSAGE_SENT_SCREEN = "MESSAGE_SENT_SCREEN";

export const terms_telcel_url = "/legal/terminoscondicionestelcel.html";
export const privacity_advice_url = "/legal/avisoprivacidad.html";
export const SOURCE = "DSC_INT"
export const PRODUCT_200_ID = 12;